export function getNewsletter(state) {
  return state.newsletter;
}
